import {useEffect, useState} from "react";
import {getCategories, listProducts} from "@corporatesclub/shared";
import {CategoryProductHub, type HubSection} from "./CategoryProductHub";
import {categorySlug, HUB_PAGE_SIZE} from "./categoryHubConstants";

const SORT_NEWEST = 8;

function categoryAllUrl(url: string): string {
  const base = url.split("?")[0];
  return `${base}?sort=${SORT_NEWEST}`;
}

export function NoutatiView() {
  const [sections, setSections] = useState<HubSection[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getCategories()
      .then(async (r) => {
        const rows = await Promise.all(r.items.map(async (category) => {
          const slug = categorySlug(category.url);
          if(!slug) return null;
          const res = await listProducts({c: slug, list: "new", sort: SORT_NEWEST, pageSize: HUB_PAGE_SIZE, page: 1});
          if(!res.items.length) return null;
          return {category, items: res.items, allUrl: categoryAllUrl(category.url)};
        }));
        setSections(rows.filter((row): row is HubSection => row !== null));
      })
      .catch(() => setSections([]))
      .finally(() => setLoading(false));
  }, []);
  return (
    <CategoryProductHub
      variant="new"
      titleKey="Latest products"
      eyebrowKey="Newest"
      leadKey="Fresh picks by category"
      sections={sections}
      loading={loading}
    />
  );
}
